export default __webpack_public_path__ + "static/hero-gradient-swoosh-f5f9028b493bed1b2ebc8e79a28f0422.png";